import React from "react";

import classNames from "classnames";
import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

import { dynamicFilterFilter } from "app/filters/dynamicFilter";

export const WinnerIcon: any = styled(SWReactIcons)`
    height: 1em;
    width: 1em;
    margin-right: 5px;
`;
WinnerIcon.displayName = "WinnerIcon";

export class LeaderDefaultCell extends React.Component<any, any> {
    private dynamicFilter: any;
    constructor(props: FixmeType) {
        super(props);
        this.dynamicFilter = dynamicFilterFilter();
    }

    render() {
        const { value, format } = this.props,
            realValue = value["Value"],
            isLeader = value["IsLeader"],
            cellFormat = format ? format : value?.format,
            classes = classNames("u-flex-row value", isLeader ? "value--leader" : "no-leader-icon-offset");

        return (
            <div className="leader-cell">
                <span className={classes}>
                    {isLeader ? <WinnerIcon iconName="winner" /> : null}
                    {realValue === null ? "N/A" : this.dynamicFilter(realValue, cellFormat)}
                </span>
                {this.props.GAVerifiedIcon}
            </div>
        );
    }
}
